import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7fd9978"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = { key: 0 }

import { useStore } from "@/composables/useTypedStore";
import Immobilie from '@/models/immobilie.model';
import { IonButton, IonContent, IonHeader, IonIcon, IonLabel, IonList, useIonRouter } from "@ionic/vue";
import { chevronForwardOutline } from "ionicons/icons";
import { computed, PropType } from 'vue';
import PropertyCard from "./PropertyCard.vue";
import PropertyItem from './PropertyItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PropertyCompactList',
  props: {
    properties: {
      type: Object as PropType<Immobilie[]>,
      required: true,
    },
    selectedPropertyId: {
      type: Number,
      required: false,
      default: null
    },
    selectedProperty: {
      type: Object as PropType<Immobilie>,
      required: false,
      default: undefined
    },
    diplaySearchResults: {
      type: String,
      required: true,
    },
    styleClasses: {
      type: String,
      required: true,
      default: "modal-content-container"
    }
},
  emits: ["open"],
  setup(__props, { emit }) {

const props = __props;



const router = useIonRouter()

const store = useStore();
const isMobile = computed(() => {
    return store.getters["app/isMobile"];
});

function open(property: Immobilie) {
  emit("open", property);
}
function handleScrollByTouchEvent(e: TouchEvent){
    if(props.selectedPropertyId !== null) {
    e.stopPropagation();
    }
}

async function goToDetailPage(prop: any) {
    await store.dispatch("app/setOpenedPropertyId", prop.id);
    if (!isMobile.value) {
        router.push({
            path: `/property/${prop.id}`
        })
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(IonHeader), { class: "ion-padding-horizontal ion-padding-top" }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }),
    _createElementVNode("div", {
      class: _normalizeClass(__props.styleClasses)
    }, [
      _createVNode(_unref(IonContent), { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (__props.selectedProperty)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_unref(IonLabel), { class: "ml-2 text-sm" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("selection")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(PropertyCard, {
                    class: "mt-0 mx-0 mb-2 rounded-lg",
                    property: __props.selectedProperty,
                    "is-compact-view": true,
                    "show-subtitle": false,
                    "custom-click-function": () => goToDetailPage(__props.selectedProperty)
                  }, {
                    header: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        class: "h-auto mt-0",
                        fill: "clear",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (goToDetailPage(__props.selectedProperty)), ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            class: "w-8 h-8",
                            title: _ctx.$t('immobilie.toOpen'),
                            icon: _unref(chevronForwardOutline)
                          }, null, 8, ["title", "icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["property", "custom-click-function"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "flex-1 overflow-y-auto",
              onTouchmove: _cache[1] || (_cache[1] = ($event: any) => (handleScrollByTouchEvent($event)))
            }, [
              _createVNode(_unref(IonLabel), { class: "ml-2 text-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.diplaySearchResults), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonList), null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.properties, (property) => {
                    return (_openBlock(), _createBlock(PropertyItem, {
                      id: `prop-item-${property.id}`,
                      key: property.id,
                      property: property,
                      selected: __props.selectedPropertyId === property.id,
                      onOpen: ($event: any) => (open(property))
                    }, null, 8, ["id", "property", "selected", "onOpen"]))
                  }), 128))
                ]),
                _: 1
              })
            ], 32)
          ])
        ]),
        _: 1
      })
    ], 2)
  ]))
}
}

})